import React from 'react';
import { Link, useParams } from 'react-router-dom';
import PublicPageLayout from '../components/landing-page/PublicPageLayout';
import { blogPosts } from './blogData';

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = blogPosts.find((item) => item.slug === slug);

  if (!post) {
    return (
      <PublicPageLayout title='Post Not Found' subtitle='The requested blog post does not exist.'>
        <Link to='/blog' className='text-amber-800 hover:text-amber-900'>
          Return to blog index
        </Link>
      </PublicPageLayout>
    );
  }

  return (
    <PublicPageLayout title={post.title} subtitle={post.excerpt}>
      <p className='text-xs uppercase tracking-wider text-gray-500 dark:text-gray-400'>{post.publishedAt}</p>
      <div className='space-y-4'>
        {post.content.map((paragraph, index) => (
          <p key={`${post.slug}-${index}`} className='leading-7 text-gray-800 dark:text-gray-200'>
            {paragraph}
          </p>
        ))}
      </div>
      <Link to='/blog' className='inline-block text-sm font-medium text-amber-800 hover:text-amber-900'>
        Back to all posts
      </Link>
    </PublicPageLayout>
  );
}
